/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 滿意度調查頁面
 * @module SatisfactionSurveyContainer
 */

// ----- import from local libraries -----
import {React} from '../../components/BaseComponent';

// ----- import from local components -----
import {useState} from 'react';
import {useSelector} from 'react-redux';
import Footer from '../../features/main-frame/components/Footer';
import Header from '../../features/main-frame/components/Header';
import Sidebar from '../../features/main-frame/components/Sidebar';
import SatisfactionModal from './components/SatisfactionModal';
import SatisfactionSurveyPage from './components/SatisfactionSurveyPage';

// ----- constants and enums -----

const SatisfactionSurveyContainer = (props) => {
  const userPermissions = useSelector((state) =>
    JSON.parse(state.access.userPermissions),
  );
  const [isOpen, setIsOpen] = useState(false);
  const [isdDataReload, setIsDataReload] = useState(false);
  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <SatisfactionSurveyPage
            {...props}
            dataReload={isdDataReload}
            dataReloadHandler={() => setIsDataReload(!isdDataReload)}
            toggleSatisfactionModal={() => setIsOpen(true)}
          />
        </div>
        <Footer />
      </div>
      <SatisfactionModal
        isOpen={isOpen}
        onOpenChange={() => setIsOpen(false)}
        reloadData={() => setIsDataReload(!isdDataReload)}
      />
    </>
  );
};

export default SatisfactionSurveyContainer;
